import { Configuration, LogLevel } from '@azure/msal-browser';
import { env } from '../../config/env';

/**
 * MSAL Configuration for Microsoft Entra ID authentication.
 * Uses the same APP_CLIENT_ID as the backend API registration.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: env.msalClientId,
    authority: `https://login.microsoftonline.com/${env.msalTenantId}`,
    redirectUri: env.msalRedirectUri,
    postLogoutRedirectUri: env.msalRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Verbose : LogLevel.Error,
    },
  },
};

/**
 * Scopes for login — requests the ContainerApps.Read scope
 * exposed by the backend API app registration.
 */
export const loginRequest = {
  scopes: [`api://${env.msalClientId}/ContainerApps.Read`],
};

/**
 * Scopes for API calls — same as login since we use a single scope.
 */
export const apiScopes = {
  containerAppsRead: [`api://${env.msalClientId}/ContainerApps.Read`],
};
